import axios from 'axios'
import Post, {IPost} from '@/models/Post'
import Tag, {ITag} from '@/models/Tag'
import PostBase from '@/components/admin/PostBase'
import { apiV1TagPath } from '@/rails/routes'

export default abstract class PostEdit extends PostBase {

  async mounted(): Promise<void> {
    super.mounted()
    const res = await axios.get<IPost>(this.targetPath)
    try {
      this.post = this.toFrontModel(res.data)
      this.loading = false
    } catch (e) {
      console.error(e)
    }
    const rootTag = await axios.get<ITag>(apiV1TagPath(this.tagCategory))
    this.tags = new Tag(rootTag.data).children
  }

  async onSave(): Promise<void> {
    this.post = await this.save()
  }

  async save(): Promise<Post> {
    try {
      const res = await axios.put(this.targetPath, {
        post: this.post.toParams()
      })
      this.showMessage('変更を保存しました。')
      return this.toFrontModel(res.data)
    } catch (e) {
      console.log(e)
      return this.post
    }
  }
}
